import React from "react";
import "./LoanAgainst.css";
import { Helmet } from "react-helmet-async";

const title = "Loan Against Cars";
const pageTitle = "Loan Against Car | Quick & Instant Cash Loan in Nigeria";
const metaDescription =
  "Need a quick cash loan? Get an instant cash loan against your car in Nigeria. Fast approval & keep driving while you repay. Apply today to get money without any hassles!";

const LoanAgainstCars = () => {
  return (
    <section className="loan-against-container">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Loan Against Cars",
            "provider": {
              "@type": "Organization",
              "name": "Respected Solution"
            },
            "areaServed": "NG"
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Loan Against Cars",
            "url": "https://www.respectedsolution.co/loan-against-cars"
          })}
        </script>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="loan-against-hero-slide"
        style={{ backgroundImage: `url(/assets/images/slider/slider-2.jpeg)` }}
      >
        <div className="loan-against-hero-overlay">
          <div className="loan-against-hero-content">
            <h1>{title}</h1>
            <p>Simple. Adjustable. Transparent.</p>
          </div>
        </div>
      </div>

      <div className="loan-against-inner">
        <div className="loan-against-inner-content">
          <section className="loan-intro">
            <p>
              Finance your travels, education, marriage, business demands, and
              other personal objectives.
            </p>
            <p>
              If you need an emergency loan and selling your vehicle might
              appear to be the only way out. But imagine if you could get cash
              and still retain your car. At Respected Solution, we provide a car
              loan in Nigeria that enables you to tap into your car's value
              without losing it.
            </p>
            <p>
              Our car-backed loan product is fast, flexible, and convenient.
              Whether you require financing for business growth, medical bills,
              or personal purposes, we offer quick approval, competitive
              interest rates, and easy repayments.
            </p>
          </section>

          <section className="loan-against-definition">
            <h2>What is Loan Against Car</h2>
            <p>
              Loan against a car or Car refinancing is a straightforward and
              stress-free borrowing option that uses your car as security. It is
              an excellent solution when you need quick naira for a variety of
              financial needs. This form of loan provides a secured option
              without the need to pledge any additional assets.
            </p>
          </section>

          <section className="loan-against-eligibility">
            <h2>
              Loan Against Car <span>Eligibility</span>
            </h2>
            <p>
              You are eligible for a loan against a car if you match the
              following criteria.
            </p>
            <p>
              To qualify for a loan against your car with Respected Solution,
              you need to meet the following requirements:
            </p>
            <ul>
              <li>Your car must be in good working condition.</li>
              <li>
                The vehicle should not have any outstanding loans or legal
                disputes.
              </li>
              <li>
                You must provide proof of ownership and valid vehicle documents.
              </li>
              <li>A valid government-issued ID.</li>
            </ul>
          </section>

          <section className="loan-against-application-steps">
            <h2>How to Apply for a Loan Against Your Car</h2>
            <ul>
              <li>Step 1: Submit Your Application</li>
              <li>Step 2: Vehicle Evaluation</li>
              <li>Step 3: Loan Approval & Documentation</li>
              <li>Step 4: Receive Your Funds</li>
            </ul>
          </section>

          <section className="loan-against-faq">
            <h2>Frequently Asked Questions</h2>
            <div className="loan-against-faq-item">
              <h3>1. What is a loan against a car?</h3>
              <p>
                A loan against car, or car title loan or auto equity loan, is a
                type of loan that enables car owners to pledge the value of
                their car as collateral for a loan. The owner of the car gets to
                keep the car while paying back the loan.
              </p>
            </div>
            <div className="loan-against-faq-item">
              <h3>2. How much can I borrow against my car?</h3>
              <p>
                The amount you can borrow usually depends on the value, age, and
                condition of the car. While our Maximum amount on each
                collateral funding is N100,000,000.
              </p>
            </div>
            <div className="loan-against-faq-item">
              <h3>
                3. What are the interest rates and repayment terms for
                car-backed loans in Nigeria?
              </h3>
              <p>
                Interest rates and payment terms differ across lenders.
                Comparing offers from several institutions and selecting the
                best terms is a good idea. Make sure you know the repayment
                amount, rate of interest, and loan duration before signing on
                the dotted line.
              </p>
            </div>
            <div className="loan-against-faq-item">
              <h3>
                4. Can I still use my car after obtaining a loan against it?
              </h3>
              <p>
                Until the borrower repays the loan, the company retains the
                vehicle in a secured facility, and the car is subsequently
                returned to the borrower. The collateral is held until the loan
                is paid back.
              </p>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default LoanAgainstCars;
